import Vue from 'vue'

const productServiceData = {
  attributeGroupsList: {
    ringSize: 1,
    metalType: 2,
    stoneType: 3,
    stoneCut: 4,
    stoneCut2: 5,
    groupColor: 8,
    stoneType2: 9,
    groupCabochon: 10,
    symbols: 11,
    necklaceSize: 12,
    beadType: 13,
    inlay: 14,
  },
  productThemesList: {
    necklaceMain: 1,
    ringMain: 2,
    ringDuo: 3,
    ringMilestone: 4,
    earringMain: 5,
    earringDuo: 6,
    braceletMain: 7,
    braceletDuo: 8,
    braceletMilestone: 9,
    pendantMain: 10,
    package: 11,
    pendantSimple: 12,
    initialPendant: 13,
    beadNecklace: 14,
    chainBracelet:15,
    beadBracelet:16,
    ringBrand: 17,
    giftCardDigital: 19,
    giftCardPhysical: 20,
    ringInitial: 21,
    ringSimple: 22,
    oneConfigProduct: 23,
    beadBraceletWithNoMetal: 24,
    ringInitialNoPave: 25,
    mosaicPendant: 26,
    earringStoneMetal: 27,
    ringStoneMetalSize: 28,
    pendantStoneMetal: 29,
    ringMetalStoneInlay: 30,
    pendantMetalStoneInlay: 32,
    stoneNecklace: 33,
    cabochonNecklace: 34,
    cabochon: 35,
    initialCharmChained: 36,
    pendantStoneMetalChained: 37,
  }
}

Vue.mixin({
  methods: {
    constProductThemes() {
      return productServiceData.productThemesList
    },
    constAttributeGroups() {
      return productServiceData.attributeGroupsList
    },
    ratingToString(num) {
      let result = '';
      if (num === 0) {
        result = 'не сформирован'
      } else if (num > 0 && num < 4) {
        result = 'плохо'
      } else if (num >= 4 && num < 7) {
        result = 'нормально'
      } else if (num >= 7 && num < 9) {
        result = 'хорошо'
      } else if (num >= 9) {
        result = 'превосходно'
      }
      return (result)
    },
    numberWithCommas(x, round = true) {
      const temp = round ? Number(x).globalRoundTo(5) : Number(x);
      return temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    roundedToUp(number) {
      return Math.ceil(Number(number || 0))
    },
    toEllipsis(string) {
      return string && string.length > 31 ? (string.substring(0, 32) + '...') : string
    },
    toEllipsisSmall(string) {
      return string && string.length > 15 ? (string.substring(0, 16) + '...') : string
    },
    goToCommercial(banner) {
      if (banner && banner.url) {
        window.open(banner.url, '_blank')
      }
    },
  }
});

export default ({ app }, inject) => {
  inject('productServiceData', productServiceData);
}
